<template>
  <el-dialog width="40%" :visible.sync="dialogVisible" append-to-body>
    <el-image
      fit="contain"
      :src="url"
      :preview-src-list="fileList"
      style="width: 100%; margin: 20px auto"
    />
  </el-dialog>
</template>
<script>
export default {
  name: "PreviewCom",
  props: ["show", "url", "urlList"],
  data() {
    return {
      fileList: [],
    };
  },
  watch: {
    urlList: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && val.length > 0) {
          this.fileList = val
            .filter((res) => {
              return this.$chargeImg(res.name, res.fileType) == true;
            })
            .map((item) => this.$operateUrl(item.url));
        } else {
          this.fileList = [];
        }
      },
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {},
};
</script>
